@use '@/styles/tokens' as *;

/* Figma `1657:790434` — the SAME translucent foot strip `field-mapping.page.module.scss .footBar`
 * ships against `594:531523`, declaration for declaration, with ONE divergence: `space-between`
 * rather than `flex-end`, because this bar has a label to push the actions away from.
 *
 * Redeclared rather than shared. A page may not import a component's CSS module and vice versa, the
 * two bars are not one component and never will be (ticket 05 swaps this one's whole control set),
 * and a mixin for eight declarations would drag a shipped page into this ticket's diff for no
 * behaviour. Change one, consider the other.
 *
 * `pr-62` in Figma rounds to `--space-16`, which lines the bar's end inset up with the control
 * stack's — the note the shipped bar already carries. `blur(2px)` is Figma's own; a filter length
 * sits on no token scale. */
.footBar {
  position: absolute;
  inset-inline: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-3) var(--space-16) var(--space-3) var(--space-6);
  background: var(--overlay-40);
  backdrop-filter: blur(2px);
}

/* `Main Font-Geist/16/R` on `text-white` (Figma `1657:790435`). Geist is the body face and needs no
 * declaration here. */
.label {
  margin: 0;
  font-size: $font-size-16;
  font-weight: $font-weight-regular;
  color: var(--text-inverse);
}

/* The actions, so the label takes the other end of `space-between` as one unit. */
.actions {
  display: flex;
  gap: var(--space-4);
  align-items: center;
  /* Pinned to the bar's end by an auto margin rather than left to `space-between`, because in
   * **Placement mode** there is no leading label and `space-between` aligns a LONE child to the
   * START — which put Cancel / Place Field in the bottom-left corner. The auto margin is correct
   * in both modes: with the label present it absorbs the same free space `space-between` did. */
  margin-inline-start: auto;
}
